module.exports = __webpack_public_path__ + "static/media/oly-large-login.e4f6cd27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Olympic/oly-large-login.jpg
// module id = 661
// module chunks = 0